// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 14">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M6.265 13.703.275 7.657A.927.927 0 0 1 0 7c0-.236.092-.472.275-.656L6.265.298a1.043 1.043 0 0 1 1.42-.037.92.92 0 0 1 .04 1.35L2.35 7l5.374 5.39a.92.92 0 0 1-.039 1.35 1.046 1.046 0 0 1-1.42-.038Z"
            />
        </svg>
    );
};

export default React.memo(CaretLeft);
